import type { ActiveCase, ResolutionEvent, RunState } from "../types/index.js";
import { discardPlayed } from "../run/discardPlayed.js";
import { createCardInstances } from "../deck/createInstance.js";

export function applyEvent(
  run: RunState,
  activeCase: ActiveCase,
  event: ResolutionEvent,
): { run: RunState; activeCase: ActiveCase } {
  switch (event.kind) {
    case "progress":
      return {
        run,
        activeCase: {
          ...activeCase,
          progress: activeCase.progress + event.gain,
          pendingProgress: 0,
        },
      };
    case "heal":
      return {
        run: { ...run, fatigue: Math.max(0, run.fatigue - event.amount) },
        activeCase,
      };
    case "load": {
      const added = createCardInstances(
        { nextCardSequence: run.nextCardSequence },
        Array.from({ length: event.addTemporaryCards?.count ?? 0 }, () => event.addTemporaryCards!.cardId),
      );
      let progress = activeCase.progress;
      if (event.progressDelta) {
        progress = Math.max(0, progress + event.progressDelta);
      }
      return {
        run: {
          ...run,
          fatigue: run.fatigue + event.fatigueDealt,
          block: 0,
          discard: [...run.discard, ...added.instances.map((card) => ({ ...card, temporaryForCase: true }))],
          nextCardSequence: added.nextCardSequence,
        },
        activeCase: {
          ...activeCase,
          progress,
          nextEnergyModifier: event.nextEnergyModifier || activeCase.nextEnergyModifier,
          nextHandDiscard: event.nextHandDiscard ?? activeCase.nextHandDiscard,
          nextActionDrawLimit: event.nextActionDrawLimit ?? activeCase.nextActionDrawLimit,
        },
      };
    }
    case "deadline":
      return {
        run,
        activeCase: { ...activeCase, deadline: event.to },
      };
    case "discard":
      return { run: discardPlayed(run, true), activeCase };
    case "overdue":
      return { run: { ...run, fatigue: run.fatigue + 5 }, activeCase };
    case "success":
      return { run, activeCase };
    case "failure":
    case "gameover":
      return { run, activeCase };
    default:
      return { run, activeCase };
  }
}
